module.exports = __webpack_public_path__ + "static/media/boat.37eb4f6d.svg";